// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  APP_VERSION: '7.5.4',
  COMPILE_DATE: 'October 13, 2026',
  GATEWAY_HANDSHAKE_TIMEOUT: 30000,
  TOAST_DEFAULT_DURATION: 8000,
  TOAST_SUCCESS_DEFAULT_DURATION: 4000,
  TOAST_ERROR_DEFAULT_DURATION: 8000,
  DEFAULT_AUTOCOMPLETE_DEBOUNCE_TIME: 800,
  DEFAULT_INPUT_DEBOUNCE_TIME: 800,
  DEFAULT_HTTP_REQUEST_TIMEOUT: 120000,
  DEFAULT_PHONE_NUMBER_FORMAT: '(XXX) XXX-XXXX Ext. XXXX',
  NUMBER_REGEX: /^(\-)?\d+(,\d{3})*(\.\d*)?$/,
  EMAIL_ADDRESS_REGEX: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
  URL_REGEX: /^(https?):\/\/((?:[a-z0-9.-]|%[0-9A-F]{2}){3,})(?::(\d+))?((?:\/(?:[a-z0-9-._~!$&'()*+,;=:@]|%[0-9A-F]{2})*)*)(?:\?((?:[a-z0-9-._~!$&'()*+,;=:\/?@]|%[0-9A-F]{2})*))?(?:#((?:[a-z0-9-._~!$&'()*+,;=:\/?@]|%[0-9A-F]{2})*))?$/i,
  MOBILE_DOCUMENTS_FOLDER: 'Quadra/ServiceCall',
  DATE_OUTPUT_FORMAT: 'MM/DD/YYYY'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
